import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SERVIZIO_AGGIUNTIVO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolServizioAggiuntivoState extends EntityState<IID_OL_SERVIZIO_AGGIUNTIVO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_SERVIZIO_AGGIUNTIVO })
export class IIDolServizioAggiuntivoStore extends EntityStore<IIDolServizioAggiuntivoState> {
  constructor() {
    super([]);
  }
}
